import React from "react";
import Modal from "@mui/material/Modal";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../pages/HomePage/HomePage";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import CancelIcon from '@mui/icons-material/Cancel';

export const BaseModal = (props) => {
    const { isOpen, setIsOpen, style, children } = props
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })

    const initialStyle = {
        position: "relative",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: "#FFFFFF",
        boxShadow: "none",
        borderRadius: "8px",
        outline: "none"
    }

    const modalStyle = style || initialStyle

    if (!children) return;

    return (
        <Modal
            open={isOpen}
            onClose={() => setIsOpen(null)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className={'BaseModal'}
        >
            <Box
                style={{
                    ...modalStyle,
                    // position: 'relative'
                }}
            >
                {/*{*/}
                {/*    isTabletOrMobile &&*/}
                {/*    <span*/}
                {/*        onClick={() => setIsOpen(null)}*/}
                {/*        style={{*/}
                {/*            position: 'absolute',*/}
                {/*            bottom: '100px',*/}
                {/*            left: '10px',*/}
                {/*            display: 'flex',*/}
                {/*            // fontWeight: 'bold',*/}
                {/*            // fontSize: '30px',*/}
                {/*            borderRadius: "50%",*/}
                {/*            color: "#A23325",*/}
                {/*            zIndex: 2000,*/}
                {/*        }}*/}
                {/*    >*/}
                {/*        <CancelIcon*/}
                {/*            sx={{*/}
                {/*                fontSize: '50px',*/}
                {/*                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",*/}
                {/*            }}*/}
                {/*            fontSize={"50px"}*/}
                {/*        />*/}
                {/*    </span>*/}
                {/*}*/}
                {children}
            </Box>
        </Modal>
    )
}